import type { FieldValidator } from 'final-form'
import isEmpty from 'lodash/isEmpty'

/** Validates that the field value is not empty (`!isEmpty`)*/
export const required =
	(errorText: string): FieldValidator<any> =>
	(value) =>
		!isEmpty(value) ? undefined : errorText
